import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";
import { createApi } from "@reduxjs/toolkit/query/react";

export const departmentApi = createApi({
  reducerPath: "departmentList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Departments"],
  endpoints: (builder) => ({
    getDepartmentData: builder.query({
      query: ({ page = 1, limit, search }) => ({
        url: Apis.departments,
        params: {
          page,
          limit,
          search,
        },
      }),
      providesTags: ["Departments"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetDepartmentDataQuery } = departmentApi;

export const departmentDetailsApi = createApi({
  reducerPath: "departmentDetails",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["DepartmentDetail"],
  endpoints: (builder) => ({
    getDepartmentDetailsById: builder.query({
      query: (id) => ({
        url: `${Apis.departments}/${id}`,
      }),
      providesTags: ["DepartmentDetail"],
      keepUnusedDataFor: 300,
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const { useGetDepartmentDetailsByIdQuery } = departmentDetailsApi;

export const employeesByDeptApi = createApi({
  reducerPath: "employeesByDept",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["EmployeesByDept"],
  endpoints: (builder) => ({
    getEmployeesByDept: builder.query({
      query: ({ page = 1, limit, search, id }) => ({
        url: `${Apis.departments}/${id}/users`,
        params: {
          page,
          limit,
          search,
        },
      }),
      providesTags: ["EmployeesByDept"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetEmployeesByDeptQuery } = employeesByDeptApi;
